export default {
  offeringLegacyTitle: "领导力传承",
  offeringLegacyDescription: "40多年的精神药物API和复杂仿制药专业经验",
  offeringGlobalTrustTitle: "全球信任",
  offeringGlobalTrustDescription: "与80多个国家的顶级制药创新者和仿制药公司建立牢固关系",
  offeringDiversePortfolioTitle: "多元化产品组合",
  offeringDiversePortfolioDescription: "在CNS、抗精神病药、抗组胺药、肌肉松弛剂领域的市场领导地位，并扩展到高壁垒疗法",
  offeringQualityComplianceTitle: "质量合规",
  offeringQualityComplianceDescription: "提供100%的质量合规性，确保每个产品一致、安全、可靠。",
  offeringIntegratedValueChainTitle: "集成价值链",
  offeringIntegratedValueChainDescription: "在KSM、API和FDF方面的端到端实力，降低供应链风险并确保可靠性",
  offeringWorldClassManufacturingTitle: "世界级制造",
  offeringWorldClassManufacturingDescription: "在卡纳塔克邦、安得拉邦的多个站点，以及意大利和美国的全球中心，从克到吨无缝扩展",
  offeringRegulatoryExcellenceTitle: "监管卓越",
  offeringRegulatoryExcellenceDescription: "在美国、欧盟和其他主要监管市场获得批准和合规",
  offeringPartnerOfChoiceTitle: "首选合作伙伴",
  offeringPartnerOfChoiceDescription: "受到全球550多家客户的信任，提供质量、速度和监管支持",
  offeringAgileSupplyChainTitle: "敏捷供应链",
  offeringAgileSupplyChainDescription: "灵活、有弹性的运营，在波动环境中确保一致交付",
  offeringSustainabilityCommitmentTitle: "可持续发展承诺",
  offeringSustainabilityCommitmentDescription: "将绿色化学、水资源积极倡议和ESG实践融入每个流程",
  offeringFutureReadyGrowthTitle: "面向未来的增长",
  offeringFutureReadyGrowthDescription: "得到Refex集团的财务实力、基础设施和全球扩张愿景的支持",
};

